export const en = {
    arrivalWarning: 'The arrival date is different from the departure date',
};
